import React, { useContext } from 'react';
import { Link } from 'gatsby';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons'

import logo from '../../assets/images/logo.svg';
import { GlobalContext } from '../../state/GlobalContext';
import Nav from './Nav'
import Wrapper from './Wrapper';

export default function Header() {

    const { setExactStep } = useContext(GlobalContext);

    return (
        <header>
            <div className="header-top bg-primary-green pt-3 pb-3">
                <Wrapper>
                    <p className="text-white text-right"><a href="tel:+48801100107"><FontAwesomeIcon icon={faPhoneAlt} size="1x" /> 801 100 107</a></p>
                </Wrapper>
            </div>
            <div className="header-main py-8">
                <Wrapper className="grid grid-cols-2 lg:grid lg:grid-cols-header-nav lg:gap-5">
                    <Link to="/" onClick={() => setExactStep(1)}><img src={logo} alt="The Air Products logo in green" /></Link>
                    <Nav showQuote="true" />
                </Wrapper>
            </div>
        </header>
    );
}